import { getData, postData } from "../../api";

export const madeToOrder = async (data) => {
  try {
    const res = await postData(`/luxury/form/made-to-order`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const CustomizationForm = async (data) => {
  try {
    const res = await postData(`/luxury/form/customization`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const RFQ = async (data) => {
  try {
    const res = await postData(`/luxuryform/rfq`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const ContactUsForm = async (data) => {
  try {
    const res = await postData(`/luxury/form/contact-us`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};
export const Subscriber = async (data) => {
  try {
    const res = await postData(`/luxury/auth/subscriber`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const TalkToUs = async (data) => {
  try {
    const res = await postData(`/luxury/form/talk-to-us`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const Suggetion = async (data) => {
  try {
    const res = await postData(`/luxury/form/suggestion`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const ProductQuery = async (data) => {
  try {
    const res = await postData(`/luxury/form/product-query`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const CanHelp = async (data) => {
  try {
    const res = await postData(`/luxury/form/can-help`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};
